import type { HopDongWizardStep } from '@/types/hop-dong';

export const HOP_DONG_WIZARD_STEPS: {
  id: HopDongWizardStep;
  label: string;
  index: number;
  iconClass: string;
}[] = [
  {
    id: 'meta',
    label: '1. Thông tin hợp đồng',
    index: 1,
    iconClass: 'fas fa-file-contract',
  },
  {
    id: 'hdvt',
    label: '2. Vật tư hợp đồng',
    index: 2,
    iconClass: 'fas fa-boxes',
  },
];

export const HOP_DONG_WIZARD_STEP_META: HopDongWizardStep = 'meta';
export const HOP_DONG_WIZARD_STEP_HDVT: HopDongWizardStep = 'hdvt';
